import {personalData} from '~/constants/privacyPolicy/data/personalData.js';
import {personalDataCollection} from '~/constants/privacyPolicy/data/personalDataCollection.js';
import {personalDataUsage} from '~/constants/privacyPolicy/data/personalDataUsage.js';
import {personalDataControl} from '~/constants/privacyPolicy/data/personalDataControl.js';
import {personalDataAgreement} from '~/constants/privacyPolicy/data/personalDataAgreement.js';
import {personalDataSecurity} from '~/constants/privacyPolicy/data/personalDataSecurity.js';
import {cookiesUsage} from '~/constants/privacyPolicy/data/cookiesUsage.js';

export const privacyPolicyData = {
    title: 'политика конфиденциальности, согласие на обработку персональных данных',
    descriptions: [
        'ООО «СИРИУС» уделяет особое внимание защите Ваших личных данных, которые могут по Вашей воле оказаться в нашем распоряжении и служить инструментом для предоставления информационных услуг на нашем сайте the4people.com.',
        'Мы обязуемся соблюдать все положения декларируемой «Политики обработки персональных данных», не превышать своих полномочий и не использовать Ваши личные данные, полученные при посещении нашего сайта в иных, не перечисленных на этой странице, целях.',
    ],
    content: [
        personalData,
        personalDataCollection,
        personalDataUsage,
        personalDataControl,
        personalDataAgreement,
        personalDataSecurity,
        cookiesUsage,
    ],
};